<h1 mat-dialog-title class="text-center">CRÉDITOS MENTOR VIRTUAL</h1>
<div mat-dialog-content>
  <p class="text-center">Insira a quantidade de tokens</p>
  <div class="parent">
    <mat-form-field>
      <div style="text-align:center;">
        <input matInput [(ngModel)]="data.qtdToken">
      </div>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions style="justify-content: center;">
  <button mat-button (click)="onNoClick()" class="text-center">Cancelar</button>
  <button mat-button [mat-dialog-close]="data.qtdToken" cdkFocusInitial class="text-center">Confirmar</button>
</div>
